import { useEffect, useState } from 'react';
import {
    useLocation,
    useNavigate,
} from 'react-router-dom';
import styled from 'styled-components';
import { useSnackbar } from "notistack";
import {
    Typography,
    Divider,
    Slider,
} from "@mui/material";
import { IconChevronLeft, IconArrowRight, IconHelpOctagon } from '@tabler/icons-react';

import {
    BuyLicenseCardContainer,
    OtherLicenseDetails,
    OtherLicenseDetailsFormContainer,
    ModuleItemContainer,
    StorageItemContainer,
    EstimateContainer,
    FormContainer,
    AmountsContainer,
    BuyErrorMessage,
    ExclamationBtn,
    BuyLicensePopperNotes,
} from '../../Styles/Licenses/buyLicenseStyles';

import { useLicenseHook } from '../../Hooks/License/licenseHooks';
import { usePriceSettingsHook } from '../../Hooks/Maintenance/PriceSettings/priceSettingsHooks';
import { useCompanyHook } from '../../Hooks/Companies/companyHooks';

import { LicenseBuy, LicenseDetailsBuy } from '../../Models/License/License';
import { Invoice, CheckoutData } from '../../Models/Billing/Billing';
import { PriceSetting, ModulePrice, UserTier, Storage } from '../../Models/Maintenance/PriceSettings/PriceSettings';

import RouteHelper from '../../Utilities/Helpers/RouteHelper';
import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import QueryBuilderHelper from '../../Utilities/Helpers/QueryBuilderHelper';
import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';
import ComputationsHelper from '../../Utilities/Helpers/ComputationsHelper';
import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { BuyLicenseField, LicenseDetailsBuyField, PriceSettingsField, InvoiceField, BillingDetailsField, BillingAddressField, CompanyListField, CheckoutDataField, CompanyField, CompanyAddressField } from '../../Utilities/Enums/ParametersEnum';
import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { ValidityTypeEnum } from "../../Utilities/Enums/ValidityTypeEnums";

import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import CustomDetailsCard from '../../CustomViews/Pages/CustomDetailsCard/CustomDetailsCard';
import FormTextField from '../../CustomViews/Elements/FormTextField';
import AutoCompleteDropdown from '../../CustomViews/Elements/AutoCompleteDropdown';
import CompanyDropdown from '../../CustomViews/Elements/AutoComplete/CompanyDropdown';
import FormValidityField from '../../CustomViews/Elements/FormValidityField';
import FormDatePicker from '../../CustomViews/Elements/FormDatePicker';
import CustomCheckbox from '../../CustomViews/Elements/CustomCheckbox';
import CustomRadioButton from '../../CustomViews/Elements/CustomRadioButton';
import CustomSwitch from '../../CustomViews/Elements/CustomSwitch';
import CustomTooltip from '../../CustomViews/Elements/CustomTooltip';
import BuyLicenseHeader from '../../CustomViews/Pages/CustomTitles/BuyLicenseHeader';
import Checkout from '../Billings/Checkout/Checkout';

export default function BuyLicensePackage() {
    //Variables
    let navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    let location = useLocation();
    let queryParams = new URLSearchParams(location.search);
    let companyid = queryParams.get('id') ?? "";
    let darkMode = LocalStorageHelper?.isDarkMode() ?? false;
    let requiredFields = RequiredParametersHelper.buyLicense();

    //Use States
    let [formData, setformData] = useState<LicenseBuy>({...new LicenseBuy()});
    let [priceSettings, setpriceSettings] = useState<PriceSetting>(new PriceSetting());

    // let [requiredFields, setrequiredFields] = useState<any>(RequiredParametersHelper.buyLicense());
    let [sliderMinValue, setsliderMinValue] = useState<number>(0);
    let [sliderMaxValue, setsliderMaxValue] = useState<number>(0);
    let [errorMessages, setErrorMessages]: any = useState({});
    let [isCheckout, setisCheckout]: any = useState<boolean>(false);
    let [initData, setinitData]: any = useState<boolean>(true);
    let [isSuccessPayment, setisSuccessPayment]: any = useState<boolean>(false);
    const [queryStr, setQueryStr] = useState({
        pageSize: 10,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.LICENSES, queryStr];
    const { DropdownData, dropdownFetchStatus } = useLicenseHook(q_queryKey, queryStr, false);
    const { data, fetchStatus } = usePriceSettingsHook([CachingEnum.PRICE_SETTINGS]);
    const { getCompanyById } = useCompanyHook(q_queryKey, queryStr, false);

    const licenseTypeProps = {
        name: LicenseDetailsBuyField.LICENSE_TYPE,
        title: 'License Type',
        fieldValue: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.LICENSE_TYPE] ?? "",
        options: DropdownData[CachingEnum.LICENSE_TYPE] ?? [],
        isLoadingDropdown: dropdownFetchStatus ?? false,
        disabled: true,
        fieldClassName: 'span2Item',
        required: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.LICENSE_DETAILS)?.fields?.find((f: any) => f.keyName == LicenseDetailsBuyField.LICENSE_TYPE)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            setformData((prev: LicenseBuy) => ({
                ...prev,
                [BuyLicenseField.LICENSE_DETAILS]: {
                    ...prev?.[BuyLicenseField.LICENSE_DETAILS],
                    [LicenseDetailsBuyField.LICENSE_TYPE]: selectedValue?.id ?? 0
                },
            }));
        },
    },
        userCapacityProps = {
            name: LicenseDetailsBuyField.USER_CAPACITY,
            title: 'User Capacity',
            fieldValue: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.USER_CAPACITY] ?? 0,
            type: 'number',
            fieldClassName: 'userCapacityField',
            isRightAlign: true,
            hideLabel: true,
            required: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.LICENSE_DETAILS)?.fields?.find((f: any) => f.keyName == LicenseDetailsBuyField.USER_CAPACITY)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                let _newValue = isNaN(parseFloat(selectedValue)) ? 0 : parseFloat(selectedValue);
                _newValue = (_newValue > sliderMaxValue ? sliderMaxValue : _newValue);
                
                computeAmounts({
                    ...formData,
                    [BuyLicenseField.LICENSE_DETAILS]: {
                        ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                        [LicenseDetailsBuyField.USER_CAPACITY]: _newValue ?? 0
                    }
                });
            },
        },
        validityProps = {
            validityTitle: 'Validity',
            validityName: LicenseDetailsBuyField.VALIDITY,
            validityValue: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.VALIDITY] ?? "",
            validityRequired: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.LICENSE_DETAILS)?.fields?.find((f: any) => f.keyName == LicenseDetailsBuyField.VALIDITY)?.keyName != null,
            validityTypeTitle: 'Validity Type',
            validityTypeName: LicenseDetailsBuyField.VALIDITY_TYPE,
            validityTypeValue: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.VALIDITY_TYPE] ?? "",
            validityTypeRequired: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.LICENSE_DETAILS)?.fields?.find((f: any) => f.keyName == LicenseDetailsBuyField.VALIDITY_TYPE)?.keyName != null,
            errorMessages: errorMessages,
            hideLabel: false,
            disabled: false,
            fieldClassName: 'span2Item',
            validityHandleOnChange: (selectedValue: any) => {
                let _invoice: any = formData?.[BuyLicenseField.INVOICE];
                let fromNow = new Date();
                let _validityType = formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.VALIDITY_TYPE] ?? ValidityTypeEnum.MONTH;
                let _plusAmount = isNaN(parseFloat(selectedValue)) ? 0 : parseFloat(selectedValue);

                if(_validityType == ValidityTypeEnum.MONTH) {
                    fromNow.setMonth(fromNow.getMonth() + _plusAmount);
                }

                if(_validityType == ValidityTypeEnum.YEAR) {
                    fromNow.setFullYear(fromNow.getFullYear() + _plusAmount);
                }


                computeAmounts({
                    ...formData,
                    [BuyLicenseField.LICENSE_DETAILS]: {
                        ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                        [LicenseDetailsBuyField.VALIDITY]: selectedValue ?? 0,
                        [LicenseDetailsBuyField.EXPIRY_DATE]: fromNow
                    },
                });
            },
            validityTypeHandleOnChange: (selectedValue: any) => {
                let _invoice: any = formData?.[BuyLicenseField.INVOICE];
                let fromNow = new Date();
                let _validityType = selectedValue?.id ?? ValidityTypeEnum.MONTH;
                let _validity: any = formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.VALIDITY] ?? "0";
                let _plusAmount: number = isNaN(parseFloat(_validity)) ? 0 : parseFloat(_validity);

                if(_validityType == ValidityTypeEnum.MONTH) {
                    fromNow.setMonth(fromNow.getMonth() + _plusAmount);
                }

                if(_validityType == ValidityTypeEnum.YEAR) {
                    fromNow.setFullYear(fromNow.getFullYear() + _plusAmount);
                }

                computeAmounts({
                    ...formData,
                    [BuyLicenseField.LICENSE_DETAILS]: {
                        ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                        [LicenseDetailsBuyField.VALIDITY_TYPE]: selectedValue?.id ?? 0,
                        [LicenseDetailsBuyField.EXPIRY_DATE]: fromNow
                    },
                    [BuyLicenseField.INVOICE]: {
                        ..._invoice,
                        [InvoiceField.IS_WITH_ANNUAL_DISCOUNT]: _validityType == ValidityTypeEnum.YEAR,
                    },
                });
            },
        },
        issueDateProps = {
            name: LicenseDetailsBuyField.ISSUE_DATE,
            title: 'License Issue Date',
            fieldValue: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.ISSUE_DATE] ?? null,
            required: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.LICENSE_DETAILS)?.fields?.find((f: any) => f.keyName == LicenseDetailsBuyField.ISSUE_DATE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: LicenseBuy) => ({
                    ...prev,
                    [BuyLicenseField.LICENSE_DETAILS]: {
                        ...prev?.[BuyLicenseField.LICENSE_DETAILS],
                        [LicenseDetailsBuyField.ISSUE_DATE]: selectedValue ?? null
                    },
                }));
            },
        },
        expiryDateProps = {
            name: LicenseDetailsBuyField.EXPIRY_DATE,
            title: 'License Expiry Date',
            fieldValue: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.EXPIRY_DATE] ?? null,
            required: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.LICENSE_DETAILS)?.fields?.find((f: any) => f.keyName == LicenseDetailsBuyField.EXPIRY_DATE)?.keyName != null,
            disabled: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: LicenseBuy) => ({
                    ...prev,
                    [BuyLicenseField.LICENSE_DETAILS]: {
                        ...prev?.[BuyLicenseField.LICENSE_DETAILS],
                        [LicenseDetailsBuyField.EXPIRY_DATE]: selectedValue ?? null
                    },
                }));
            },
        },
        issuedCompanyProps = {
            name: LicenseDetailsBuyField.COMPANY_PUBLIC_ID,
            title: 'Issued Company',
            fieldValue: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.COMPANY_PUBLIC_ID] ?? "",
            required: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.LICENSE_DETAILS)?.fields?.find((f: any) => f.keyName == LicenseDetailsBuyField.COMPANY_PUBLIC_ID)?.keyName != null,
            errorMessages: errorMessages,
            fieldClassName: 'span2Item',
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({
                    ...prev,
                    [BuyLicenseField.LICENSE_DETAILS]: {
                        ...prev?.[BuyLicenseField.LICENSE_DETAILS],
                        [LicenseDetailsBuyField.COMPANY_PUBLIC_ID]: selectedValue?.id ?? null
                    },
                    [BuyLicenseField.INVOICE]: {
                        ...prev?.[BuyLicenseField.INVOICE],
                        [InvoiceField.BILLING_DETAILS]: {
                            ...prev?.[BuyLicenseField.INVOICE]?.[InvoiceField.BILLING_DETAILS],
                            [BillingDetailsField.COMPANY_PUBLIC_ID]: selectedValue?.id ?? null,
                            [BillingDetailsField.NAME]: selectedValue?.[CompanyListField.NAME] ?? "",
                            [BillingDetailsField.CONTACT_PERSON]: selectedValue?.[CompanyListField.CONTACT_PERSON] ?? "",
                            [BillingDetailsField.CONTACT_PHONE]: selectedValue?.[CompanyListField.CONTACT_PHONE] ?? "",
                            [BillingDetailsField.EMAIL]: selectedValue?.[CompanyListField.EMAIL] ?? "",
                            [BillingDetailsField.ADDRESS]: {
                                ...prev?.[BuyLicenseField.INVOICE]?.[InvoiceField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                                ...selectedValue?.[CompanyListField.ADDRESS],

                                [BillingAddressField.FULL_ADDRESS]: selectedValue?.[CompanyListField.FULL_ADDRESS] ?? "",
                            },
                        }
                    }
                }));
            },
        };
        // discountProps = {
        //     name: BuyLicenseField.DISCOUNT_AMOUNT,
        //     title: 'Discount',
        //     fieldValue: formData?.[BuyLicenseField.DISCOUNT_AMOUNT] ?? 0,
        //     type: 'number',
        //     isRightAlign: true,
        //     hideLabel: true,
        //     required: requiredFields?.find((field: any) => field.keyName == BuyLicenseField.DISCOUNT_AMOUNT)?.keyName != null,
        //     errorMessages: errorMessages,
        //     handleOnChange: (selectedValue: any) => {
        //         computeAmounts({...formData,[BuyLicenseField.DISCOUNT_AMOUNT]: selectedValue });
        //     },
        // };

    //Event Handlers
    const initializeCompany = async () => {
        if(companyid != '0') {
            
            let getDetails = await getCompanyById(companyid);

            if(getDetails?.data?.[CompanyField.PUBLIC_ID] != null && getDetails?.data?.[CompanyField.PUBLIC_ID] != "") {
                setformData((prev: any) => ({
                    ...prev,
                    [BuyLicenseField.LICENSE_DETAILS]: {
                        ...prev?.[BuyLicenseField.LICENSE_DETAILS],
                        [LicenseDetailsBuyField.COMPANY_PUBLIC_ID]: getDetails?.data?.[CompanyField.PUBLIC_ID] ?? null
                    },
                    [BuyLicenseField.INVOICE]: {
                        ...prev?.[BuyLicenseField.INVOICE],
                        [InvoiceField.BILLING_DETAILS]: {
                            ...prev?.[BuyLicenseField.INVOICE]?.[InvoiceField.BILLING_DETAILS],
                            [BillingDetailsField.COMPANY_PUBLIC_ID]: getDetails?.data?.[CompanyField.PUBLIC_ID] ?? null,
                            [BillingDetailsField.NAME]: getDetails?.data?.[CompanyField.NAME] ?? "",
                            [BillingDetailsField.CONTACT_PERSON]: getDetails?.data?.[CompanyField.CONTACT_PERSON] ?? "",
                            [BillingDetailsField.CONTACT_PHONE]: getDetails?.data?.[CompanyField.CONTACT_PHONE] ?? "",
                            [BillingDetailsField.EMAIL]: getDetails?.data?.[CompanyField.EMAIL] ?? "",
                            [BillingDetailsField.ADDRESS]: {
                                ...prev?.[BuyLicenseField.INVOICE]?.[InvoiceField.BILLING_DETAILS]?.[BillingDetailsField.ADDRESS],
                                ...getDetails?.data?.[CompanyField.ADDRESS],

                                [BillingAddressField.FULL_ADDRESS]: getDetails?.data?.[CompanyField.ADDRESS]?.[CompanyAddressField.FULL_ADDRESS] ?? "",
                            },
                        }
                    }
                }));
            }
        }
    }

    const initializePriceSettings = async (_priceSetting: PriceSetting) => {
        let _userTiersSettings: UserTier[] = _priceSetting?.[PriceSettingsField.USER_TIERS] ?? [];

        let _sliderMinValue = _userTiersSettings[0]?.[PriceSettingsField.MIN_USERS] ?? 0;
        let _sliderMaxValue = _userTiersSettings[_userTiersSettings?.length - 1]?.[PriceSettingsField.MAX_USERS] ?? 0;
        let fromNow = new Date();
        let invoiceData: Invoice = formData?.[BuyLicenseField.INVOICE] ?? new Invoice();
        
        fromNow.setFullYear(fromNow.getFullYear() + 1);

        setpriceSettings(_priceSetting);
        setsliderMinValue(_sliderMinValue);
        setsliderMaxValue(_sliderMaxValue);
        setformData({
            ...formData,
            [BuyLicenseField.LICENSE_DETAILS]: {
                ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                [LicenseDetailsBuyField.LICENSE_TYPE]: 1,
                [LicenseDetailsBuyField.VALIDITY]: 1,
                [LicenseDetailsBuyField.VALIDITY_TYPE]: ValidityTypeEnum.MONTH,
                [LicenseDetailsBuyField.EXPIRY_DATE]: fromNow,
                [LicenseDetailsBuyField.ISSUE_DATE]: new Date(),
            },
            
            [BuyLicenseField.INVOICE]: {
                ...invoiceData,
                [InvoiceField.ANNUAL_DISCOUNT_RATE]: _priceSetting?.[PriceSettingsField.ANNUAL_BILLING_DISCOUNT] ?? 0,
            }
        });

        setinitData(false);
    }

    const computeAmounts = async (_formData: LicenseBuy) => {
        let _computeData = await ComputationsHelper.buyLicenseComputeAmounts(_formData, priceSettings);

        setformData(_computeData);
    }

    const handleSubmit = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        setisCheckout(true);

        //API Integration HERE

        // let generateResponse = await generateLicense(JSON.stringify(formData));

        // if(generateResponse?.isSuccess) {
        //     navigate(`${RouteEnum.LICENSES}`, { replace: true });
        // }
    }

    useEffect(() => {
        if(companyid) {
            initializeCompany();
        }
    }, []);

    useEffect(() => {
        if(fetchStatus != "fetching" && initData) {
            initializePriceSettings(data?.data);
        }
    }, [fetchStatus, data, initData]);

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Back'
                startIcon={<IconChevronLeft />}
                // isRoundedCorner={true}
                onClick={(e: any) => {
                    GlobalFunctionHelper.goBack(navigate, location, RouteEnum.LICENSES);
                }} />
        </>
    }

    const renderNoOfEmployees = () => {
        return <div className="otherDetailsFormContainer">
            <div className="otherDetailsHeaderTitleContainer span3Item">
                <Typography color="primaryText" className="otherDetailsHeaderTitle">Number of Employees</Typography>
                <Typography color="primaryText" className="otherDetailsSubHeaderTitle">Total employees in your company</Typography>
            </div>
            <Slider
                className="userCapacitySlider span3Item"
                aria-label="Small steps"
                value={formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.USER_CAPACITY] ?? 0}
                step={1}
                marks={[
                    {
                        value: sliderMinValue,
                        label: sliderMinValue?.toString(),
                    },
                    {
                        value: sliderMaxValue,
                        label: (sliderMaxValue?.toString()) + '+',
                    },
                ]}
                min={sliderMinValue}
                max={sliderMaxValue}
                valueLabelDisplay="auto"
                onChange={(event: Event, newValue: number) => {
                    computeAmounts({
                        ...formData,
                        [BuyLicenseField.LICENSE_DETAILS]: {
                            ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                            [LicenseDetailsBuyField.USER_CAPACITY]: newValue ?? 0
                        }
                    });
                }} />

            {errorMessages?.[LicenseDetailsBuyField.USER_CAPACITY] && <BuyErrorMessage className="span3Item">{errorMessages?.[LicenseDetailsBuyField.USER_CAPACITY] ?? ""}</BuyErrorMessage>}
        </div>
    }

    const renderPopperNotes = (popperNoteTitle: any, popperNoteDescription: any) => {
        return <CustomTooltip {...{
                tooltipName: <BuyLicensePopperNotes>
                    {popperNoteTitle && <Typography color="primaryText" className="popperNoteTitle">{popperNoteTitle ?? "--"}</Typography>}
                    {popperNoteTitle && <Divider className="popperNoteDivider" />}
                    <Typography color="primaryText" className="popperNoteDescription">{popperNoteDescription ?? "--"}</Typography>
                </BuyLicensePopperNotes>,
                placement: "right",
                slotProps:{
                    tooltip: {
                        sx: {
                            padding: '0px',
                            background: (darkMode ? '#292b2c' : '#ffffff'),
                            boxShadow: `1px 1px 5px 1px ${(darkMode ? '#ffffff1f' : 'gray')}`,
                        },
                    },
                    arrow: {
                        sx: {
                            color: (darkMode ? '#292b2c' : '#ffffff'),
                        },
                    },
                },
                tooltipContent: <ExclamationBtn size="small" className="exclamationHoverItemDisplayBtn">
                    <IconHelpOctagon />
                </ExclamationBtn>,
            }} />
    }

    const renderModules = () => {
        return <div className="otherDetailsFormContainer">
            <div className="otherDetailsHeaderTitleContainer span3Item">
                <Typography color="primaryText" className="otherDetailsHeaderTitle">Modules</Typography>
                <Typography color="primaryText" className="otherDetailsSubHeaderTitle">Choose your modules</Typography>
            </div>

            {priceSettings?.[PriceSettingsField.MODULES]?.map((mod: any, moduleIndex: number) => {
                let _modulePrice: any = ComputationsHelper.computeModPrice((mod?.[PriceSettingsField.MODULE_BASE_PRICE] ?? 0), 1, (formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.IS_WITH_ANNUAL_DISCOUNT] ?? false));
                let _monthlyText: any = formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.IS_WITH_ANNUAL_DISCOUNT] ? "Yearly" : "Monthly";

                return <>
                    <ModuleItemContainer sx={{borderColor: 'customBorder.main'}} $darkMode={darkMode} onClick={(e) => {
                        e.preventDefault();

                        let _isSelected = formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.MODULES]?.find(item => item == mod?.[PriceSettingsField.MODULE_PUBLIC_ID]) ? true : false;
                        let _modules = formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.MODULES] ?? [];

                        if(_isSelected) {
                            _modules = _modules.filter(item => item != mod?.[PriceSettingsField.MODULE_PUBLIC_ID]);
                        } else {
                            _modules.push(mod?.[PriceSettingsField.MODULE_PUBLIC_ID]);
                        }

                        computeAmounts({
                            ...formData,
                            [BuyLicenseField.LICENSE_DETAILS]: {
                                ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                                [LicenseDetailsBuyField.MODULES]: _modules
                            }
                        });
                    }}>
                        <div className="moduleCheckboxContainer">
                            <CustomCheckbox name={LicenseDetailsBuyField.MODULES + moduleIndex}
                                title={mod?.[PriceSettingsField.MODULE_NAME] ?? "--"}
                                checkboxType={ButtonType.PRIMARY}
                                fieldValue={formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.MODULES]?.find(item => item == mod?.[PriceSettingsField.MODULE_PUBLIC_ID]) ? true : false}
                                handleOnChange={(a: any) => { }}
                                errorMessages={errorMessages} />

                                <Typography color="primaryText" className="moduleItemPrice">{GlobalFunctionHelper.amountFormatter((_modulePrice), 2, true)} / {_monthlyText}</Typography>
                        </div>

                        {renderPopperNotes((mod?.[PriceSettingsField.MODULE_NAME] ?? "--"), (mod?.[PriceSettingsField.MODULE_DESCRIPTION] ?? "--"))}

                        <div className="clickerDiv" />
                    </ModuleItemContainer>
                </>
            })}

            {errorMessages?.[LicenseDetailsBuyField.MODULES] && <BuyErrorMessage className="span3Item">{errorMessages?.[LicenseDetailsBuyField.MODULES] ?? ""}</BuyErrorMessage>}
        </div>
    }

    const renderStorages = () => {
        return <div className="otherDetailsFormContainer">
            <div className="otherDetailsHeaderTitleContainer span3Item">
                <Typography color="primaryText" className="otherDetailsHeaderTitle">Storage</Typography>
                {/*<Typography color="primaryText" className="otherDetailsSubHeaderTitle">Choose your storage plan (one-time charge)</Typography>*/}
                <Typography color="primaryText" className="otherDetailsSubHeaderTitle">Choose your storage plan</Typography>
            </div>

            {priceSettings?.[PriceSettingsField.STORAGES]?.map((stor: any, storageIndex: number) => {
                let _storagePrice: any = ComputationsHelper.computeStorageCapacityPrice((stor?.[PriceSettingsField.STORAGE_PRICE] ?? 0), (formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.IS_WITH_ANNUAL_DISCOUNT] ?? false));
                let _monthlyText: any = formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.IS_WITH_ANNUAL_DISCOUNT] ? "Yearly" : "Monthly";
                let _storagePopperNote: any = stor?.[PriceSettingsField.STORAGE] ? StaticDisplayText.UP_TO_TOTAL + (stor?.[PriceSettingsField.STORAGE] ?? "0") + StaticDisplayText.GB_STORAGE_FOR : "--";

                return <>
                    <StorageItemContainer sx={{borderColor: 'customBorder.main'}} $darkMode={darkMode} onClick={(e) => {
                        e.preventDefault();

                        computeAmounts({
                            ...formData,
                            [BuyLicenseField.LICENSE_DETAILS]: {
                                ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                                [LicenseDetailsBuyField.STORAGE_CAPACITY]: stor?.[PriceSettingsField.STORAGE] ?? 0

                            },
                        });
                    }}>
                        <div className="storageItemCheckboxContainer">
                            <CustomRadioButton name={LicenseDetailsBuyField.STORAGE_CAPACITY + storageIndex}
                                title={"Storage"}
                                hideLabel={true}
                                radioButtonType={ButtonType.PRIMARY}
                                fieldValue={formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.STORAGE_CAPACITY]}
                                options={[{
                                    id: stor?.[PriceSettingsField.STORAGE],
                                    name: <div className="radioButtonSideLabelContainer">
                                        <Typography className="storageGBText">{(stor?.[PriceSettingsField.STORAGE] ?? "0")} GB</Typography>
                                        <Typography className="storagePriceText">({GlobalFunctionHelper.amountFormatter(_storagePrice, 2, true)} / {_monthlyText})</Typography>
                                    </div>
                                }]}
                                handleOnChange={(a: any) => { }}
                                errorMessages={errorMessages} />
                            <Typography color="primaryText" className="storageItemDescription">{stor?.[PriceSettingsField.STORAGE_DESCRIPTION] ?? "--"}</Typography>
                        </div>

                        {renderPopperNotes(null, _storagePopperNote)}

                        <div className="clickerDiv" />
                    </StorageItemContainer>
                </>
            })}

            {errorMessages?.[LicenseDetailsBuyField.STORAGE_CAPACITY] && <BuyErrorMessage className="span3Item">{errorMessages?.[LicenseDetailsBuyField.STORAGE_CAPACITY] ?? ""}</BuyErrorMessage>}
        </div>
    }

    const renderOtherLicenseDetails = () => {
        return <OtherLicenseDetails sx={{borderColor: 'customBorder.main'}}>
            <OtherLicenseDetailsFormContainer>
                {renderNoOfEmployees()}
                {renderModules()}
                {renderStorages()}
            </OtherLicenseDetailsFormContainer>
            <EstimateContainer $darkMode={darkMode}>
                <CustomSwitch 
                    name={InvoiceField.IS_WITH_ANNUAL_DISCOUNT}
                    title={"Bill Yearly (" + (formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.ANNUAL_DISCOUNT_RATE] ?? 0) + "% off)"}
                    switchType={ButtonType.PRIMARY}
                    fieldValue={formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.IS_WITH_ANNUAL_DISCOUNT] ?? false}
                    handleOnChange={(a: any) => {
                        let _invoiceData: Invoice = formData?.[BuyLicenseField.INVOICE] ?? new Invoice();
                        let fromNow = new Date();
                        let _validityType = a ? ValidityTypeEnum.YEAR : ValidityTypeEnum.MONTH;
                        let _validity: any = formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.VALIDITY] ?? "0";
                        let _plusAmount: number = isNaN(parseFloat(_validity)) ? 0 : parseFloat(_validity);

                        if(_validityType == ValidityTypeEnum.MONTH) {
                            fromNow.setMonth(fromNow.getMonth() + _plusAmount);
                        }

                        if(_validityType == ValidityTypeEnum.YEAR) {
                            fromNow.setFullYear(fromNow.getFullYear() + _plusAmount);
                        }

                        computeAmounts({
                            ...formData,
                            [BuyLicenseField.LICENSE_DETAILS]: {
                                ...formData?.[BuyLicenseField.LICENSE_DETAILS],
                                [LicenseDetailsBuyField.VALIDITY_TYPE]: a ? ValidityTypeEnum.YEAR : ValidityTypeEnum.MONTH,
                                [LicenseDetailsBuyField.EXPIRY_DATE]: fromNow,
                            },
                            [BuyLicenseField.INVOICE]: {
                                ..._invoiceData,
                                [InvoiceField.IS_WITH_ANNUAL_DISCOUNT]: a,
                            },
                        });
                    }}
                    errorMessages={errorMessages} />

                <Divider className="divider" />

                <div className="upToTextContainer">
                    <Typography color="primaryText" className="upToText">Up to</Typography>
                    <FormTextField {...userCapacityProps} />
                    {/*<Typography color="primaryText" className="empCount">{formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.USER_CAPACITY] ?? 0}</Typography>*/}
                    <Typography color="primaryText" className="upToText">employees</Typography>
                </div>

                <Divider className="divider" />

                <Typography color="primaryText" className="estimateTotalCostText">Estimate Total Cost</Typography>

                <div className="estimatedTotalCostContainer">
                    <Typography className="estimatedTotalCost">{GlobalFunctionHelper.amountFormatter(formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.LINE_TOTAL] ?? 0, 2, true)}</Typography>
                    <Typography className="monthlyText">/ {formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.IS_WITH_ANNUAL_DISCOUNT] ? "Yearly" : "Monthly"}</Typography>
                </div>
                
                {formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.IS_WITH_ANNUAL_DISCOUNT] && <div className="youSavedTextContainer">
                    <Typography className="youSavedText">You Saved:</Typography>
                    <Typography className="savedAmount">{GlobalFunctionHelper.amountFormatter(formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.ANNUAL_DISCOUNT_AMOUNT] ?? 0, 2, true)}</Typography>
                </div>}

                <Typography className="baseOnSelectedText">{StaticDisplayText.BASE_ON_SELECTED}</Typography>
                
            </EstimateContainer>
        </OtherLicenseDetails>
    }

    const renderAmounts = () => {
        return <AmountsContainer $darkMode={darkMode}>
            <div className="itemContainer">
                <Typography color='primaryText' className="amountItems">Sub Total:</Typography>
                <Typography color='primaryText' className="amountItems rightItems">{GlobalFunctionHelper.amountFormatter(formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.SUB_TOTAL] ?? 0, 2, true)}</Typography>
            </div>
            <div className="itemContainer">
                <Typography color='primaryText' className="amountItems">Tax ({formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TAX_RATE]}%):</Typography>
                <Typography color='primaryText' className="amountItems rightItems">{GlobalFunctionHelper.amountFormatter(formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TAX_AMOUNT] ?? 0, 2, true)}</Typography>
            </div>
            <div className="itemContainer">
                <Typography color='primaryText' className="amountItems">Grand Total (Before Rounding):</Typography>
                <Typography color='primaryText' className="amountItems rightItems">{GlobalFunctionHelper.amountFormatter(formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TOTAL_BEFORE_ADJUSTMENT] ?? 0, 2, true)}</Typography>
            </div>
            <div className="itemContainer">
                <Typography color='primaryText' className="amountItems">Rounding Adjust:</Typography>
                <Typography color='primaryText' className="amountItems rightItems">{GlobalFunctionHelper.amountFormatter(formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.ROUND_ADJUSTMENT] ?? 0, 2, true)}</Typography>
            </div>

            <Divider className="divider" />
            
            <div className="itemContainer grandTotalContainer">
                <div className="grandTotalTextContainer">
                    <Typography color='primaryText' className="amountItems">Grand Total</Typography>
                    <Typography color='primaryText' className="afterRoundingText">(After Rounding) :</Typography>
                </div>
                <Typography color='primaryText' className="amountItems rightItems">{GlobalFunctionHelper.amountFormatter(formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TOTAL_AFTER_ADJUSTMENT] ?? 0, 2, true)}</Typography>
            </div>
        </AmountsContainer>
    }

    const renderForm = () => {
        return <FormContainer>
            <BuyLicenseHeader
                headerTitle={"Choose the plan that's right for you"}
                headerSubTitle={"Simple pricing. No hidden fees. Advanced features for you business."} />

            <AutoCompleteDropdown {...licenseTypeProps} />

            {renderOtherLicenseDetails()}
            
            <FormValidityField {...validityProps} />

            <FormDatePicker {...issueDateProps} />
            <FormDatePicker {...expiryDateProps} />
            
            <CompanyDropdown {...issuedCompanyProps} />

            {renderAmounts()}

            <CustomButton
                className="checkoutBtn"
                btnType={ButtonType.SUCCESS}
                title='Checkout'
                startIcon={<IconArrowRight />}
                // isRoundedCorner={true}
                onClick={(e: any) => {
                    handleSubmit();
                }} />
        </FormContainer>
    }

    const renderBuyLicense = () => {
        return <BuyLicenseCardContainer>
            <CustomDetailsCard
            title={RouteHelper.getRouteDescription(RouteEnum.BUY_LICENSE)}
            actionButtons={renderActionButtons()} >
                {renderForm()}
            </CustomDetailsCard>
        </BuyLicenseCardContainer>
    }

    const renderCheckout = () => {
        return <Checkout
            formData={formData}
            checkoutData={{
                ...new CheckoutData(),
                [CheckoutDataField.VALIDITY]: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.VALIDITY],
                [CheckoutDataField.VALIDITY_TYPE]: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.VALIDITY_TYPE],
                [CheckoutDataField.MODULES]: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.MODULES],
                [CheckoutDataField.USER_CAPACITY]: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.USER_CAPACITY],
                [CheckoutDataField.STORAGE_CAPACITY]: formData?.[BuyLicenseField.LICENSE_DETAILS]?.[LicenseDetailsBuyField.STORAGE_CAPACITY],

                [CheckoutDataField.LINE_TOTAL]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.LINE_TOTAL],
                [CheckoutDataField.SUB_TOTAL]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.SUB_TOTAL],
                [CheckoutDataField.TAX_RATE]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TAX_RATE],
                [CheckoutDataField.TAX_AMOUNT]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TAX_AMOUNT],
                [CheckoutDataField.TOTAL_BEFORE_ADJUSTMENT]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TOTAL_BEFORE_ADJUSTMENT],
                [CheckoutDataField.ROUND_ADJUSTMENT]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.ROUND_ADJUSTMENT],
                [CheckoutDataField.TOTAL_AFTER_ADJUSTMENT]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.TOTAL_AFTER_ADJUSTMENT],
                [CheckoutDataField.BILLING_DETAILS]:  formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.BILLING_DETAILS],
                [CheckoutDataField.DISCOUNT_AMOUNT]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.DISCOUNT_AMOUNT],
                [CheckoutDataField.CURRENCY_CODE]: formData?.[BuyLicenseField.INVOICE]?.[InvoiceField.CURRENCY_CODE],
            }}
            onClickBackBtn={() => { setisCheckout(false); }}
            isSuccessPayment={isSuccessPayment}
            setisSuccessPayment={setisSuccessPayment} />
    }

    return <>
        {!isCheckout && renderBuyLicense()}
        {isCheckout && renderCheckout()}
    </>
}
